mx.comp.CheckAllColumn = function(config, rowcheckcallback) {
    Ext.apply(
        this,
        Ext.apply(
            {
                width: 20,
                sortable: false,
                resizable: false,
                hideable: false,
                fixed: true,
                menuDisabled: true,
                customCls: 'x-grid3-check-col',
                toCommit: false,
            },
            config
        )
    );

    if (!this.id) {
        this.id = Ext.id();
    }
    this.header = '<div class="' + this.customCls + ' x-grid3-cc-' + this.id + '" style="width: 18px">&#160;</div>';
    this.renderer = this.renderer.createDelegate(this);

    this.rowcheckcallback = rowcheckcallback;
};

mx.comp.CheckAllColumn.prototype = {
    init: function(grid) {
        this.grid = grid;
        this.grid.on(
            'render',
            function() {
                var view = this.grid.getView();

                view.mainBody.on('mousedown', this.onMouseDown, this);
                Ext.fly(view.innerHd).on('mousedown', this.onHdMouseDown, this);
                this.renderHeader(view);
            },
            this
        );

        this.store = this.grid.getStore();
    },

    renderHeader: function(view) {
        var h = Ext.fly(Ext.query('div[class*=x-grid3-hd-' + this.id + ']', view.innerHd.dom)[0]);
        if (h) {
            h.addClass('maxoptra-comp-checkallcolumn-hd');
            this.headerElement = h.child('div');
            if (this.checked) {
                this.headerElement.addClass(this.customCls + '-on');
            }
        }
    },

    uncheckHeader: function() {
        this.checked = false;
        this.checkEl(this.headerElement, false);
    },

    onMouseDown: function(e, t) {
        if (t.className && t.className.indexOf('x-grid3-cc-' + this.id) != -1) {
            e.stopEvent();
            var index = this.grid.getView().findRowIndex(t);
            var record = this.store.getAt(index);
            var value = !record.data[this.dataIndex];
            this.modifyRecord(record, value);
            this.check(t, value);
            if (this.handler) {
                this.handler.call(this.scope || this, record.data[this.dataIndex], record);
            }
        }
    },

    onHdMouseDown: function(e, t) {
        if (t.className && t.className.indexOf('x-grid3-cc-' + this.id) != -1) {
            e.stopEvent();
            this.checkAll(t, this.hdCheck(t));
        }
    },

    hdCheck: function(/*Dom element*/ el) {
        var cell = Ext.fly(el);
        this.checked = !this.checked;
        this.checkEl(cell, this.checked);

        return this.checked;
    },

    renderer: function(v, p, record) {
        if (record.get(this.hideProperty)) {
            return '';
        } else {
            p.css += ' x-grid3-check-col-td';
            var cls = this.customCls || 'x-grid3-check-col';
            var tooltip = this.tooltip ? ' ext:qtip="' + this.tooltip + '"' : '';
            return (
                '<div' +
                tooltip +
                ' class="' +
                cls +
                (v ? ' ' + this.customCls + '-on' : '') +
                ' x-grid3-cc-' +
                this.id +
                '">&#160;</div>'
            );
        }
    },

    check: function(/*Dom element*/ el, /*boolean*/ toCheck) {
        if (!toCheck) {
            var header = Ext.query('div[class*=x-grid3-cc-' + this.id + ']', this.grid.getView().innerHd.dom)[0];
            var hd = Ext.fly(header);
            var checked = hd.hasClass(this.customCls + '-on');
            this.checked = false;
            if (checked) {
                this.checkEl(hd, false);
            }
        }

        var cell = Ext.fly(el);
        this.checkEl(cell, toCheck);

        if (this.rowcheckcallback) {
            this.rowcheckcallback.call(this.scope || this);
        }
    },

    checkEl: function(/*Element*/ el, /*boolean*/ toCheck) {
        if (toCheck) {
            el.addClass(this.customCls + '-on');
        } else {
            el.removeClass(this.customCls + '-on');
        }
    },
    setStore: function(store) {
        this.store = store;
    },
    checkAll: function(/*Dom element*/ el, /*boolean*/ toCheck, /*Number*/ colIndex) {
        var cellIndex = typeof colIndex != 'undefined' ? colIndex : this.grid.getView().findCellIndex(el);
        var store = this.store;
        var count = store.getCount();
        var records = new Array();
        for (var i = 0; i < count; i++) {
            var cell = this.grid.getView().getCell(i, cellIndex);
            var checkbox = Ext.query('div[class*=x-grid3-cc-]', cell)[0];
            checkbox = Ext.fly(checkbox);

            if (checkbox != null) {
                var record = store.getAt(i);
                records.push(record);
                this.modifyRecord(record, toCheck);
                if (toCheck) {
                    checkbox.addClass(this.customCls + '-on');
                } else {
                    checkbox.removeClass(this.customCls + '-on');
                }
            }
        }
        if (this.rowcheckcallback) {
            this.rowcheckcallback.call(this.scope || this);
        }
        if (this.hdHandler) {
            this.hdHandler.call(this.scope || this, toCheck, records);
        }
    },

    checkAllWithId: function(/*Integer*/ id, /*boolean*/ toCheck, /*Number*/ colIndex) {
        var store = this.store;
        var count = store.getCount();
        for (var i = 0; i < count; i++) {
            var record = store.getAt(i);
            if (record.get('id') == id && this.grid.rendered) {
                var cell = this.grid.getView().getCell(i, colIndex);

                var checkbox = Ext.query('div[class*=x-grid3-cc-]', cell)[0];
                checkbox = Ext.fly(checkbox);

                if (toCheck) {
                    checkbox.addClass(this.customCls + '-on');
                } else {
                    checkbox.removeClass(this.customCls + '-on');
                }
            }
        }
    },

    modifyRecord: function(record, value) {
        var oEditing = record.editing;
        record.editing = !this.toCommit;
        record.set(this.dataIndex, value);
        record.editing = oEditing;
        if (!this.toCommit) {
            record.isDirty = false;
            if (record.modified) {
                delete record.modified[this.dataIndex];
            }
        }
    },

    checkByRowIndex: function(rowIndex) {
        var c = Ext.fly(this.grid.getView().getRow(rowIndex)).query('.x-grid3-cc-' + this.id)[0];
        this.onMouseDown({stopEvent: Ext.emptyFn}, c);
    },
};
Ext.grid.RadioColumn = function(config) {
    Ext.apply(this, config);
    if (!this.id) {
        this.id = Ext.id();
    }
    this.renderer = this.renderer.createDelegate(this);
};

Ext.grid.RadioColumn.prototype = {
    init: function(grid) {
        this.grid = grid;
        this.grid.on(
            'render',
            function() {
                var view = this.grid.getView();
                view.mainBody.on('mousedown', this.onMouseDown, this);
            },
            this
        );
    },

    onMouseDown: function(e, t) {
        if (t.className && t.className.indexOf('x-grid3-cc-' + this.id) != -1) {
            e.stopEvent();
            var index = this.grid.getView().findRowIndex(t);
            var record = this.grid.store.getAt(index);
            this.grid.store.suspendEvents();
            var allRecords = this.grid.store.getRange();
            for (var i = 0; i < allRecords.length; i++) {
                allRecords[i].set(this.dataIndex, false);
            }
            record.set(this.dataIndex, this.inputValue);
            this.grid.store.resumeEvents();
            this.grid.getView().refresh();
        }
    },

    renderer: function(v, p, record) {
        p.css += ' x-grid3-radio-col-td';
        return (
            '<div class="x-grid3-radio-col' +
            (v == this.inputValue ? '-on' : '') +
            ' x-grid3-cc-' +
            this.id +
            '"> </div>'
        );
    },
};
